// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"100":"149b7aa0","305":"149b7aa0","457":"149b7aa0","626":"149b7aa0","983":"149b7aa0"}[chunkId] + ".chunk.css";
};